import React from 'react';
import { CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import type { Toast } from '../types';

interface ToastContainerProps {
  toasts: Toast[];
}

const ToastIcon: React.FC<{ type: Toast['type'] }> = ({ type }) => {
  switch (type) {
    case 'success':
      return <CheckCircle size={18} className="text-green-500" />;
    case 'error':
      return <AlertCircle size={18} className="text-red-500" />;
    case 'warning':
      return <AlertTriangle size={18} className="text-amber-500" />;
    case 'info':
    default:
      return <Info size={18} className="text-blue-500" />;
  }
};

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts }) => {
  return (
    <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[200] flex flex-col gap-3 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="glass-high px-4 py-3 rounded-xl shadow-2xl flex items-center gap-3 animate-slide-down pointer-events-auto border border-white/10"
        >
          <ToastIcon type={toast.type} />
          <span className="text-sm font-medium text-white">{toast.message}</span>
        </div>
      ))}
    </div>
  );
};

export default React.memo(ToastContainer);
